// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"32":"HomeView","86":"CoursesView","132":"PolicyView","372":"CourseView","373":"RulesView","705":"ContactsView"}[chunkId] + "." + {"32":"577fdd0f","86":"ef75a320","132":"1e1b9f23","372":"b4ac5203","373":"20cf75e7","705":"c1ddc3ad"}[chunkId] + ".js";
};